import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, reject } from 'lodash';
import { columnName } from 'utils/Formatters';
import PlayerCheckbox from './PlayerCheckbox';
import PlayerImage from './PlayerImage';
import PlayerTextArea from './PlayerTextArea';

const PlayerResponseTypes = {
  checkbox: PlayerCheckbox,
  image: PlayerImage,
  textarea: PlayerTextArea,
};

const getAnswer = (r, survey, path) => {
  const answerId = get(r, path);
  const InputType = PlayerResponseTypes[r.inputType];
  return <InputType key={`${path}-${r.id}`}
    responseType={r} answer={answerId ? survey.entities.answers[answerId] : null} />;
}

// const getAnswerOptions = (r) => {
//   if (r.inputType !== 'checkbox') return r.label;
//   return <ul className='no-bullet'>
//     { r.possibleAnswers.map((a, idx) => <li key={`checkbox-${r.id}-${idx}`}>{a.label}</li>) }
//   </ul>
// }

const PlayerQuestionModal = ({ qId, survey }) => {
  const teacherSurvey = survey.entities.surveys[survey.result.questionnaires.teacher];
  const parentSurvey = survey.entities.surveys[survey.result.questionnaires.parent];
  const question = survey.entities.questions[qId];
  const responses = question.responseTypes.map(i => survey.entities.responseTypes[i]);
  const optional = reject(responses, {'inputType': 'radio'});
  const rows = optional.map( (r, idx) =>
    <div key={`row-${qId}-${idx}`} className='o-rtable__row o-rtable__row--bt-bordered'>
      <div className='o-player-cell'>{r.label}</div>
      { teacherSurvey && getAnswer(r, survey, 'answer.teacher') }
      {getAnswer(r, survey, teacherSurvey ? 'answer.parent' : 'answer')}
    </div>
  );
  return (
    <div className='column u-margin-top--base u-margin-bottom--base'>
      <h2 className='u-txt--base'><b>{question.boldBody}</b></h2>
      <hr className='u-margin-top--zero'/>
      <div className='o-rtable u-margin-bottom--base'>
        <div className='o-rtable__row'>
          <div className='o-player-cell'></div>
          { teacherSurvey && <div className='o-player-cell'>{columnName(teacherSurvey.respondentName || "Teacher")}</div> }
          <div className='o-player-cell'>{columnName(parentSurvey.respondentName)}</div>
        </div>
        {rows}
      </div>
    </div>
  )
}


const mapStateToProps = (state, ownProps) => {
  return {
    survey: state.player.survey,
    qId: ownProps.qId,
  }
}

PlayerQuestionModal.propTypes = {
  survey: PropTypes.object.isRequired,
  qId: PropTypes.number.isRequired,
}

export default connect(mapStateToProps, null)(PlayerQuestionModal)
